import type { ReactNode } from 'react';
import { NavLink } from 'react-router';

/**
 * **Un lien du menu — et il DIT OÙ L'ON EST.**
 *
 * `NavLink` de React Router rend l'état actif, et `aria-current="page"` part avec lui : sans
 * lui, la page courante est signalée par une couleur et **par elle seule**, donc pas signalée
 * du tout pour qui navigue au clavier ou à la voix. C'est la même exigence que l'anneau de
 * focus toujours visible de `styles.css` — « un produit qu'un stylet pilote reste un produit
 * qu'un clavier doit pouvoir traverser ».
 *
 * **`NavLink` et non `<a>`, et ce n'est pas un détail de confort.** Un `<a href>` recharge la
 * page entière : le paquet JavaScript est retéléchargé, et l'accueil **rappellerait la
 * route publique** à chaque passage d'une page à l'autre. Le routage déclaratif ne fait ni
 * l'un ni l'autre.
 *
 * **Le lien vers la connexion n'est PAS de ce composant**, et l'écart est une règle : F-71 —
 * « le chemin vers la connexion existe depuis chacune des sept autres pages, **dans le
 * menu** », et « le chemin dit **toujours** "se connecter" ». Toujours, parce que « les sept
 * autres pages **ne savent rien de personne** : elles montrent la même chose à tout le
 * monde ». Il est donc rendu comme une action et non comme un onglet de navigation — voir
 * `CadreDuSite`.
 */
export function LienDeNavigation({
  vers,
  children,
}: {
  readonly vers: string;
  readonly children: ReactNode;
}) {
  return (
    <NavLink
      to={vers}
      className={({ isActive }) =>
        [
          'inline-flex min-h-cible items-center rounded-2 px-3',
          'text-16 font-weight-700',
          isActive ? 'text-texte-fort' : 'text-texte-faible hover:text-texte',
        ].join(' ')
      }
    >
      {children}
    </NavLink>
  );
}
